import { makeDefaultApi } from './request';
import { I18nText } from '../i18n_text';
import { CountryData } from './countries';

export interface GlobalRegionData {
  id?: string;
  name_json: I18nText;
  countries?: CountryData[];
}

export const { list, retrieve, save, remove } = makeDefaultApi<GlobalRegionData>('global_regions');
